import React, { FC } from "react"
import { Text } from "dash-styled"
import { Link } from "resha"

interface AlreadyUserProps {
    loginRoute: string
    className?: string
}
export const AlreadyUser: FC<AlreadyUserProps> = ({
    className,
    loginRoute
}) => {
    return (
        <Text
            color="gray"
            component="div"
            className={`text-center px-8 ${className ?? ""}`}
        >
            Already have an account?{" "}
            <Link to={loginRoute} className="text-violet">
                Log in
            </Link>
        </Text>
    )
}
